import styled from 'styled-components';
import FdrProductRecommenderSliderContent from 'components/domain/fdr-product-recommender/fdr-product-recommender-slider-content';

export const BookmarkGroupItemLink = styled.a.attrs({ href: '#' })<{
  active: boolean;
}>(({ theme: { colors }, active }) => ({
  display: 'block',
  padding: '10px',
  border: '1px solid transparent',
  borderRadius: '5px',
  backgroundColor: colors.paperGrey,
  '&:hover': {
    borderColor: colors.primary,
    boxShadow: '0px 10px 24px 0px rgba(0, 0, 0, 0.25)',
    '.bookmark-group-item-image > div': {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  ...(active && {
    borderColor: colors.primary,
    '.bookmark-group-item-image > div': {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  }),
}));

export const BookmarkGroupItemInfo = styled.div({
  display: 'flex',
  marginTop: '20px',
});

export const BookmarkGroupItemTitle = styled.div(
  ({ theme: { fontSizes } }) => ({
    fontSize: fontSizes[1],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexGrow: 1,
  })
);

export const BookmarkGroupItemCount = styled.div(({ theme: { colors } }) => ({
  color: colors.primary,
}));

export const BookmarkGroupItemImage = styled.div({
  height: '230px',
  position: 'relative',
  '> div': {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    bottom: '-10px',
    left: '-10px',
    img: {
      width: '100%',
      height: '100%',
    },
    transition: '0.3s ease',
  },
});

export const BookmarkGroupItemButtons = styled.div(({ theme: { colors } }) => ({
  display: 'flex',
  marginTop: '10px',
  justifyContent: 'space-between',
  button: {
    display: 'block',
    flexBasis: '24px',
    '.bookmark-edit': {
      fill: 'transparent',
    },
    '&:hover': {
      color: colors.primary,
    },
  },
}));

export const BookmarkGroupSlider = styled(FdrProductRecommenderSliderContent)({
  '.card-section-arrow-pagination': {
    marginTop: '-42px',
  },
});
